(function($){
  window.ExitModal = {
    DOM_IDENTIFIER: '.js-exit-modal',
    DAYS_BETWEEN_MODAL_DISPLAYS: 3,

    execute: function(variant) {
      if(variant === 'treatment') {
        document.addEventListener("mouseleave", function(e) {
          if(window.ExitModal.shouldRender()) {
            $(window.ExitModal.DOM_IDENTIFIER).modal('show');
            window.ExitModal.setLocalStorageExpiration();
          }
        }, false);
      }
    },

    shouldRender: function() {
      var endOfNoDisplayPeriod = localStorage.getItem('exit-modal-expiration');
      if(endOfNoDisplayPeriod) {
        return (new Date()).getTime() >= JSON.parse(endOfNoDisplayPeriod)
      }
      return true;
    },

    setLocalStorageExpiration: function() {
      var currentDate = new Date();
      var dateEligibleForAnotherDisplay = currentDate.setDate(currentDate.getDate() + this.DAYS_BETWEEN_MODAL_DISPLAYS);
      localStorage.setItem('exit-modal-expiration', dateEligibleForAnotherDisplay);
    }
  }
})($);
